import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import Container from "semantic-ui-react/dist/es/elements/Container/Container"
import "./App.css"
import AppContent from "./AppContent"
import AppFooter from "./AppFooter"
import AppHeader from "./AppHeader"
const App = ({ children }) => {
  return (
    <Container data-testid="container">
      <Grid>{children}</Grid>
    </Container>
  )
}

App.Header = AppHeader
App.Content = AppContent
App.Footer = AppFooter

export default App
